import Switch from "@components/atoms/switch";
import Typography from "@mui/material/Typography";

import { SwitchContainer, Title } from "./switchWrapper.styled";
import { ComponentProps } from "./switchWrapper.type";

const SwitchWrapper = ({
  label,
  checked,
  defaultChecked,
  handleChange,
}: ComponentProps) => {
  return (
    <SwitchContainer>
      <Title>{label}</Title>
      <Switch
        checked={checked}
        handleChange={handleChange}
        defaultChecked={defaultChecked}
      />
    </SwitchContainer>
  );
};

export default SwitchWrapper;
